import React from 'react';
import {
    OPEN_STATUS,
    ORDER_HISTORY_FILTER_LAST2YEARS,
    ORDER_HISTORY_FILTER_LAST3MONTH,
    ORDER_HISTORY_FILTER_LASTMONTH
} from '../configuration';
import { ILxsBillingDocumentsResources } from '../modules/lxs-billing-documents/lxs-billing-documents.props.autogenerated';
import { IOrderHistoryResources } from '../modules/order-history';
import { DateFilterGroup } from '../modules/order-history/components/date-filter-group';
import { DebouncedInput } from '../modules/order-history/components/debounced-input';

export interface ISearchBoxProps {
    globalFilter: string;
    resources: ILxsBillingDocumentsResources | IOrderHistoryResources;
    currentView: any;
    activeButton: any;
    showSearchBoxFilters: boolean;
    setGlobalFilter: React.Dispatch<React.SetStateAction<string>>;
    setCurrentView: any;
    handleTimeFilterClick: any;
    handleOpenFilterClick: any;
}

const isOrderResources = (r: ILxsBillingDocumentsResources | IOrderHistoryResources): r is IOrderHistoryResources =>
    'orderHistorySearchLabel' in r;

const SearchBox: React.FC<ISearchBoxProps> = ({
    globalFilter,
    resources,
    currentView,
    activeButton,
    showSearchBoxFilters,
    setGlobalFilter,
    handleOpenFilterClick,
    handleTimeFilterClick
}) => {
    const CLASS_NAME = 'lxs-search-box';
    const label = isOrderResources(resources) ? resources.orderHistorySearchLabel : resources.lxsBillingDocumentsSearchLabel;

    const placeholder = isOrderResources(resources)
        ? resources.orderHistorySearchPlaceholder
        : resources.lxsBillingDocumentsSearchPlaceholder;

    const orderResources = resources as IOrderHistoryResources;

    const dateFilterOptions = isOrderResources(resources)
        ? [
              { label: orderResources.orderHistoryFilterLastMonth, value: ORDER_HISTORY_FILTER_LASTMONTH },
              { label: orderResources.orderHistoryFilterLastThreeMonths, value: ORDER_HISTORY_FILTER_LAST3MONTH },
              { label: orderResources.orderHistoryFilterLastTwoYears, value: ORDER_HISTORY_FILTER_LAST2YEARS }
          ]
        : [];

    return (
        <div className={`msc-section-box ${CLASS_NAME}__search-section-box`}>
            <div className={`${CLASS_NAME}__search`}>
                <fieldset className={`msc-form__group ${CLASS_NAME}__search-input`}>
                    <label htmlFor='soldTosSearch' className='sr-only'>
                        {label}
                    </label>
                    <DebouncedInput
                        type='search'
                        value={globalFilter ?? ''}
                        onChange={(value: string) => {
                            setGlobalFilter(String(value));
                        }}
                        placeholder={placeholder}
                        data-cy='order-history__search-box'
                        className={`${CLASS_NAME}__search-input`}
                    />
                </fieldset>
            </div>
            {showSearchBoxFilters && isOrderResources(resources) && (
                <div className={`${CLASS_NAME}__search-filter`}>
                    <button
                        className={`${CLASS_NAME}__search-filter-button ${
                            currentView === OPEN_STATUS ? 'msc-cta__primary' : 'msc-cta__secondary'
                        }`}
                        onClick={handleOpenFilterClick}
                    >
                        {resources.orderHistoryOpenOrdersButtonPlaceholder}
                    </button>

                    <DateFilterGroup
                        className={CLASS_NAME}
                        options={dateFilterOptions}
                        activeValue={activeButton}
                        onChange={handleTimeFilterClick}
                    />
                </div>
            )}
        </div>
    );
};

export default SearchBox;
